import type { BoundingBox, PnidEquipment, PnidInstrument } from '../types';

/**
 * The box the canvas centers on for one equipment or one instrument. An equipment
 * the SME has not marked yet falls back to the AI's tag label, so it can still be found.
 */
export function navigationBoxOf(kind: 'equipment', item: PnidEquipment | undefined): BoundingBox | null;
export function navigationBoxOf(kind: 'instrument', item: PnidInstrument): BoundingBox | null;
export function navigationBoxOf(
  kind: 'equipment' | 'instrument',
  item: PnidEquipment | PnidInstrument | undefined,
): BoundingBox | null {
  if (kind === 'equipment') {
    const equipment = item as PnidEquipment | undefined;
    return equipment?.bbox ?? equipment?.label_bbox ?? null;
  }
  return (item as PnidInstrument).bbox ?? null;
}
